const roles = [
  { id: 1, name: "NGO", enumName: "ROLE_NGO" },
  { id: 2, name: "Admin", enumName: "ROLE_ADMIN" },
];

export default roles;
